import T from 'prop-types';
import React from 'react';
import List from './list';

const DraftsList = props => {
  const { drafts, pending, onEpisodeClicked } = props;
  const items = Array.isArray(drafts) ? drafts : [];

  return (
    <List
      className="show-page__drafts-list drafts-list"
      episodes={items}
      pending={pending}
      emptyMessage="No drafts."
      onEpisodeClicked={onEpisodeClicked}
      createdColumnHeading="Created"
    />
  );
};

DraftsList.propTypes = {
  drafts: T.array,
  pending: T.bool.isRequired,
  onEpisodeClicked: T.func.isRequired,
};

export default DraftsList;
